export interface HealthcareCreateOrderPayload {
  category: string;
  sub_category: string;
  amount: string;
  donor_name: string;
  mobile_number: string;
  email: string;
  city: string;
  full_address: string;
  state: string;
  pincode: string;
  country: string;
  occasion?: string;
  display_name?: string;
  special_instructions?: string;
  is_anonymous: boolean;
  info_confirmed: boolean;
  contact_consent: boolean;
  mode: string;
}

export interface HealthcareCreateOrderResult {
  order_id: string;
  amount: number;
  currency: string;
  key_id?: string;
  donation_id?: number;
}

export interface HealthcareVerifyPaymentPayload {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

export interface HealthcareVerifyPaymentResult {
  receipt_no?: string;
  message?: string;
}

export interface HealthcareDonation {
  id: number;
  category: string;
  sub_category: string;
  amount: string;
  donor_name: string;
  mobile_number: string;
  email: string;
  city: string;
  full_address: string;
  state: string;
  pincode: string;
  country: string;
  occasion?: string;
  display_name?: string;
  special_instructions?: string;
  is_anonymous: boolean;
  info_confirmed: boolean;
  contact_consent: boolean;
  mode: string;
  payment_mode?: string;
  payment_reference?: string;
  status: string;
  receipt_no?: string;
  created_at?: string;
  updated_at?: string;
}

export interface HealthcareAddDonationPayload {
  category: string;
  sub_category: string;
  amount: string;
  donor_name: string;
  mobile_number: string;
  email: string;
  city: string;
  full_address: string;
  state: string;
  pincode: string;
  country: string;
  occasion?: string;
  display_name?: string;
  special_instructions?: string;
  is_anonymous: boolean;
  info_confirmed: boolean;
  contact_consent: boolean;
  mode: "offline";
  payment_mode: "cash" | "cheque" | "neft" | "rtgs" | "imps" | "upi";
  payment_reference: string;
}

export function parseHealthcareCreateOrderResponse(
  response: unknown
): HealthcareCreateOrderResult {
  const root = response as {
    order_id?: string;
    amount?: number;
    currency?: string;
    key_id?: string;
    donation_id?: number;
    data?: {
      order_id?: string;
      amount?: number;
      currency?: string;
      key_id?: string;
      donation_id?: number;
    };
  };

  if (root.order_id) {
    return {
      order_id: root.order_id,
      amount: root.amount ?? 0,
      currency: root.currency ?? "INR",
      key_id: root.key_id,
      donation_id: root.donation_id,
    };
  }

  return {
    order_id: root.data?.order_id ?? "",
    amount: root.data?.amount ?? 0,
    currency: root.data?.currency ?? "INR",
    key_id: root.data?.key_id,
    donation_id: root.data?.donation_id,
  };
}

export function parseHealthcareVerifyPaymentResponse(
  response: unknown
): HealthcareVerifyPaymentResult {
  const root = response as {
    receipt_no?: string;
    message?: string;
    data?: { receipt_no?: string; receipt_number?: string; message?: string };
  };
  return {
    receipt_no:
      root.receipt_no ?? root.data?.receipt_no ?? root.data?.receipt_number,
    message: root.message ?? root.data?.message,
  };
}
